<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="iconSize"
        :height="iconSize"
        :viewBox="viewBox"
        fill="none"
        aria-hidden="true"
        class="leo-sparkle-icon"
        :class="{
            'leo-sparkle-icon--new-ui': isNewUi,
            'leo-sparkle-icon--breathing': breathing,
            'leo-sparkle-icon--orbiting': orbiting
        }">
        <template v-if="isNewUi">
            <rect
                v-if="filled"
                width="24"
                height="24"
                rx="4"
                :fill="`url(#leo-sparkle-pattern-${$.uid})`" />
            <rect
                v-if="filled"
                width="24"
                height="24"
                rx="4"
                class="leo-sparkle-icon__filled-overlay"
                fill-opacity="0.1" />
            <g
                class="leo-sparkle-icon__star"
                :class="{ 'leo-sparkle-icon__star--spinning': spinning }">
                <path
                    v-if="filled"
                    d="M11.2138 4.65296C11.2481 4.46949 11.3454 4.30377 11.489 4.18452C11.6326 4.06527 11.8134 4 12 4C12.1866 4 12.3674 4.06527 12.5111 4.18452C12.6546 4.30377 12.7519 4.46949 12.7863 4.65296L13.6268 9.0983C13.6866 9.41436 13.8401 9.70508 14.0675 9.93248C14.295 10.1599 14.5856 10.3135 14.9017 10.3732L19.3471 11.2138C19.5305 11.2481 19.6963 11.3454 19.8155 11.489C19.9347 11.6326 20 11.8134 20 12C20 12.1866 19.9347 12.3674 19.8155 12.511C19.6963 12.6546 19.5305 12.7519 19.3471 12.7862L14.9017 13.6269C14.5856 13.6866 14.295 13.8401 14.0675 14.0675C13.8401 14.295 13.6866 14.5856 13.6268 14.9017L12.7863 19.3471C12.7519 19.5306 12.6546 19.6963 12.5111 19.8155C12.3674 19.9347 12.1866 20 12 20C11.8134 20 11.6326 19.9347 11.489 19.8155C11.3454 19.6963 11.2481 19.5306 11.2138 19.3471L10.3732 14.9017C10.3135 14.5856 10.1599 14.295 9.93247 14.0675C9.70507 13.8401 9.41436 13.6866 9.09829 13.6269L4.65296 12.7862C4.46949 12.7519 4.30377 12.6546 4.18452 12.511C4.06527 12.3674 4 12.1866 4 12C4 11.8134 4.06527 11.6326 4.18452 11.489C4.30377 11.3454 4.46949 11.2481 4.65296 11.2138L9.09829 10.3732C9.41436 10.3135 9.70507 10.1599 9.93247 9.93248C10.1599 9.70508 10.3135 9.41436 10.3732 9.0983L11.2138 4.65296Z"
                    class="leo-sparkle-icon__filled-star-highlight"
                    fill-opacity="0.3" />
                <path
                    d="M11.2138 4.65296C11.2481 4.46949 11.3454 4.30377 11.489 4.18452C11.6326 4.06527 11.8134 4 12 4C12.1866 4 12.3674 4.06527 12.5111 4.18452C12.6546 4.30377 12.7519 4.46949 12.7863 4.65296L13.6269 7.86369C13.7444 8.48582 14.0467 9.05806 14.4943 9.50566C14.9421 9.95325 15.5142 10.2557 16.1364 10.3732L19.3471 11.2138C19.5305 11.2481 19.6963 11.3454 19.8155 11.489C19.9347 11.6326 20 11.8134 20 12C20 12.1866 19.9347 12.3674 19.8155 12.511C19.6963 12.6546 19.5305 12.7519 19.3471 12.7862L16.1364 13.6269C15.5142 13.772 14.9421 14.1455 14.4943 14.6984C14.0467 15.2516 13.7444 15.9583 13.6269 16.7268L12.7863 19.3471C12.7519 19.5306 12.6546 19.6963 12.5111 19.8155C12.3674 19.9347 12.1866 20 12 20C11.8134 20 11.6326 19.9347 11.489 19.8155C11.3454 19.6963 11.3022 19.5306 11.2679 19.3471L10.3732 16.7268C10.2281 15.9583 9.85443 15.2516 9.30154 14.6984C8.74865 14.1455 8.0418 13.772 7.2733 13.6269L4.65296 12.7862C4.46949 12.7519 4.30377 12.6546 4.18452 12.511C4.06527 12.3674 4 12.1866 4 12C4 11.8134 4.06527 11.6326 4.18452 11.489C4.30377 11.3454 4.46949 11.2481 4.65296 11.2138L7.86418 10.3732C8.48619 10.2557 9.05831 9.95325 9.50582 9.50566C9.95332 9.05806 10.2557 8.48582 10.3732 7.86369L11.2138 4.65296Z"
                    :class="{ 'leo-sparkle-icon__filled-star': filled }"
                    :fill="filled ? null : `url(#leo-sparkle-gradient-${$.uid})`" />
            </g>
            <defs>
                <pattern
                    v-if="filled"
                    :id="`leo-sparkle-pattern-${$.uid}`"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1">
                    <use
                        :href="`#leo-sparkle-image-${$.uid}`"
                        transform="translate(-0.172646) scale(0.00224215)" />
                </pattern>
                <linearGradient
                    v-if="!filled"
                    :id="`leo-sparkle-gradient-${$.uid}`"
                    x1="4"
                    y1="4"
                    x2="19.6"
                    y2="20.4"
                    gradientUnits="userSpaceOnUse">
                    <stop class="leo-sparkle-icon__star-gradient-start" />
                    <stop
                        offset="1"
                        class="leo-sparkle-icon__star-gradient-end" />
                </linearGradient>
                <image
                    v-if="filled"
                    :id="`leo-sparkle-image-${$.uid}`"
                    width="600"
                    height="446"
                    preserveAspectRatio="none"
                    :href="leoGradientImage" />
            </defs>
        </template>
        <template v-else>
            <rect
                v-if="!circleHidden"
                v-bind="circleAttrs"
                class="leo-sparkle-icon__circle" />
            <rect
                v-if="!circleHidden"
                v-bind="circleAttrs"
                :stroke="`url(#apsi-border-${$.uid})`" />
            <path
                class="leo-sparkle-icon__star"
                :class="{ 'leo-sparkle-icon__star--spinning': spinning }"
                d="M12.1227 18.9766C12.0918 19.1069 11.9063 19.1066 11.8758 18.9762L11.3105 16.564C11.0888 15.6218 10.6087 14.7601 9.92432 14.0757C9.2399 13.3912 8.37821 12.9112 7.43602 12.6895L5.02605 12.1248C4.89553 12.0942 4.89544 11.9084 5.02593 11.8777L7.43603 11.3105C8.37821 11.0888 9.2399 10.6088 9.92432 9.92433C10.6087 9.23991 11.0888 8.37821 11.3105 7.43603L11.8752 5.02605C11.9058 4.89553 12.0916 4.89544 12.1223 5.02593L12.6895 7.43603C12.9087 8.38099 13.3877 9.24588 14.0723 9.93314C14.7569 10.6204 15.6199 11.1027 16.564 11.3256L18.9741 11.8928C19.1046 11.9235 19.1045 12.1093 18.974 12.1399L16.564 12.7046C15.6248 12.9261 14.7657 13.4043 14.0826 14.0858C13.3995 14.7673 12.9192 15.6253 12.6955 16.564L12.1227 18.9766Z"
                vector-effect="non-scaling-stroke"
                fill-opacity="1"
                :stroke="`url(#apsi-sparkle-${$.uid})`" />
            <defs>
                <linearGradient
                    :id="`apsi-border-${$.uid}`"
                    x1="12"
                    y1="0"
                    x2="31.125"
                    y2="27.375"
                    gradientUnits="userSpaceOnUse">
                    <stop class="leo-sparkle-icon__circle-border-gradient-start" />
                    <stop
                        offset="1"
                        class="leo-sparkle-icon__circle-border-gradient-end" />
                </linearGradient>
                <linearGradient
                    :id="`apsi-sparkle-${$.uid}`"
                    x1="8.3384"
                    y1="8.201"
                    x2="16.0679"
                    y2="17.3626"
                    gradientUnits="userSpaceOnUse">
                    <stop class="leo-sparkle-icon__star-gradient-start" />
                    <stop
                        offset="1"
                        class="leo-sparkle-icon__star-gradient-end" />
                </linearGradient>
            </defs>
        </template>
        <g
            v-if="orbiting"
            class="leo-sparkle-icon__orbit-track">
            <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 12 12"
                to="360 12 12"
                dur="3.5s"
                repeatCount="indefinite" />
            <circle
                v-for="dot in orbitingDots"
                :key="dot.index"
                class="leo-sparkle-icon__orbit-dot"
                :class="`leo-sparkle-icon__orbit-dot--${dot.index}`"
                :cx="dot.cx"
                :cy="dot.cy"
                r="1.35" />
        </g>
    </svg>
</template>

<script>
import useUiVersion from '@/common/use/use-ui-version/use-ui-version';
import leoGradientImage from '@img/agents/ui-refresh/leo-gradient.png';

export default {
    name: 'LeoSparkleIcon',
    props: {
        size: {
            type: [Number, String],
            default: 24,
        },
        circleHidden: {
            type: Boolean,
            default: false,
        },
        spinning: {
            type: Boolean,
            default: false,
        },
        filled: {
            type: Boolean,
            default: false,
        },
        breathing: {
            type: Boolean,
            default: false,
        },
        orbiting: {
            type: Boolean,
            default: false,
        },
    },
    setup () {
        const { isNewUi } = useUiVersion();

        return {
            isNewUi,
            leoGradientImage,
        };
    },
    computed: {
        circleAttrs () {
            return {
                x: 0.5,
                y: 0.5,
                width: 23,
                height: 23,
                rx: 11.5,
                'vector-effect': 'non-scaling-stroke',
            };
        },
        iconSize () {
            return this.orbiting ? 42 : this.size;
        },
        orbitingDots () {
            const center = 12;
            const radius = 16.5;

            return [1, 2, 3, 4, 5, 6, 7, 8].map((index) => {
                const angle = ((index - 1) * 45 - 90) * (Math.PI / 180);

                return {
                    index,
                    cx: center + radius * Math.cos(angle),
                    cy: center + radius * Math.sin(angle),
                };
            });
        },
        viewBox () {
            return this.orbiting ? '-9 -9 42 42' : '0 0 24 24';
        },
    },
};
</script>

<style scoped lang="less">
.leo-sparkle-icon {
    vertical-align: middle;
    flex-shrink: 0;

    &__circle {
        fill: var(--leo-sparkle-icon-circle-background-base, var(--palette-gray-0));
    }

    &--breathing {
        transform-box: fill-box;
        transform-origin: center;
        animation: lsb-breathe 2.2s ease-in-out infinite;
    }

    &--orbiting {
        overflow: visible;
    }

    &__orbit-dot--1 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-1-base); opacity: 1; }
    &__orbit-dot--2 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-2-base); opacity: 0.9; }
    &__orbit-dot--3 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-1-base); opacity: 0.78; }
    &__orbit-dot--4 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-2-base); opacity: 0.62; }
    &__orbit-dot--5 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-1-base); opacity: 0.45; }
    &__orbit-dot--6 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-2-base); opacity: 0.3; }
    &__orbit-dot--7 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-1-base); opacity: 0.18; }
    &__orbit-dot--8 { fill: var(--leo-sparkle-icon-circle-border-orbit-step-2-base); opacity: 0.1; }

    &__star {
        fill: var(--leo-sparkle-icon-star-fill-base, var(--palette-teal-30));
        transform-box: fill-box;
        transform-origin: center;

        &--spinning {
            animation: sparkle-spin 0.5s ease-in-out;
        }
    }

    &__circle-border-gradient-start {
        stop-color: var(--leo-sparkle-icon-circle-border-gradient-start-base, var(--palette-purple-50));
    }

    &__circle-border-gradient-end {
        stop-color: var(--leo-sparkle-icon-circle-border-gradient-end-base, var(--palette-teal-30));
    }

    &__star-gradient-start {
        stop-color: var(--leo-sparkle-icon-star-gradient-start-base, var(--palette-purple-50));
    }

    &__star-gradient-end {
        stop-color: var(--leo-sparkle-icon-star-gradient-end-base, var(--palette-teal-40));
    }

    &__filled-star {
        fill: var(--static-leo-sparkle-icon-filled-star-fill-base);
    }

    &__filled-star-highlight {
        fill: var(--leo-sparkle-icon-filled-star-highlight-fill-base);
    }

    &__filled-overlay {
        fill: var(--leo-sparkle-icon-filled-overlay-background-base);
    }

    &--new-ui {
        .leo-sparkle-icon__orbit-dot--1,
        .leo-sparkle-icon__orbit-dot--3,
        .leo-sparkle-icon__orbit-dot--5,
        .leo-sparkle-icon__orbit-dot--7 {
            fill: var(--static-leo-sparkle-icon-circle-border-orbit-step-1-base);
        }

        .leo-sparkle-icon__orbit-dot--2,
        .leo-sparkle-icon__orbit-dot--4,
        .leo-sparkle-icon__orbit-dot--6,
        .leo-sparkle-icon__orbit-dot--8 {
            fill: var(--static-leo-sparkle-icon-circle-border-orbit-step-2-base);
        }

        .leo-sparkle-icon__star-gradient-start {
            stop-color: var(--leo-sparkle-icon-star-gradient-start-base);
        }

        .leo-sparkle-icon__star-gradient-end {
            stop-color: var(--leo-sparkle-icon-star-gradient-end-base);
        }
    }
}

@keyframes sparkle-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

@keyframes lsb-breathe {
    0%, 100% { transform: scale(0.85); }
    50% { transform: scale(1.1); }
}

</style>
